import { ChartSeries } from '../types';
import { DeltaRow, FAN_NEVER_OFF_MESSAGE } from './transitionDeltaSeries';

interface TooltipEntry {
  payload: DeltaRow;
}

interface Props {
  active?: boolean;
  payload?: TooltipEntry[];
  label?: string;
  series: ChartSeries[];
  isOverlay: boolean;
  averageLabel?: string;
}

const TransitionDeltaTooltip = ({ active, payload, label, series, isOverlay, averageLabel }: Props) => {
  if (!active || !payload?.length) return null;
  const row = payload[0].payload;
  return (
    <div className="bg-white p-2 border border-border rounded-sm shadow-md">
      <p className="text-sm font-medium">{isOverlay ? label ?? row.date : row.date}</p>
      {series.map((item) => {
        const delta = row[`delta_${item.id}`];
        const hollow = row[`hollow_${item.id}`];
        const average = averageLabel ? row[`average_${item.id}`] : null;
        return (
          <div key={item.id}>
            {typeof delta === 'number' && (
              <p className="text-sm" style={isOverlay ? { color: item.color } : undefined}>
                {isOverlay ? `${item.label}: ` : 'Delta: '}{Math.round(delta)} Pa
              </p>
            )}
            {typeof hollow === 'number' && (
              <p className="text-sm" style={isOverlay ? { color: item.color } : undefined}>
                {isOverlay ? `${item.label}: ` : ''}{FAN_NEVER_OFF_MESSAGE}
              </p>
            )}
            {typeof average === 'number' && (
              <p className="text-sm" style={isOverlay ? { color: item.color } : undefined}>
                {isOverlay ? `${item.label} — ` : ''}{averageLabel}: {average.toFixed(2)} Pa
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TransitionDeltaTooltip;
